import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyWatchSettingsOverflowMenuShortcut: LoadableType<any> = LoadableLazy<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-watch-settings-menu-shortcut" */ '../src/WatchSettingsOverflowMenuShortcut.tsx'
			)
		).WatchSettingsOverflowMenuShortcut,
});
